import React, { useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import AddChequeFormStyle from './css/AddChequeFormStyle'
import CloseButton from '../../../layout/close_button/CloseButton'
import { formatNumber, getMonthString } from '../../../utilities/utilities'

function AddChequeForm(props) {
  const { payments, addPayments } = props
  const existingCheques = payments.find(payment => payment.name === 'Cheques')

  const initCheque = {
    number: '',
    date: '',
    bank: '',
    amount: 0.00
  }
  const chequeNumberRef = useRef(null)
  const [cheque, setCheque] = useState(initCheque )
  const [chequesList, setChequesList] = useState((existingCheques) ? existingCheques.cheques : [])
  const [addOK, setAddOK] = useState(false)
  const [editMode, setEditMode] = useState(false)
  const [currentIndex, setCurrentIndex] = useState(null)

  const onClickApply = (e) => {
    addPayments({
      name: 'Cheques',
      total: totalChequeAmount(),
      cheques: chequesList
    })
    ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
  }

  const onClickCancel = (e) => {
    // Probably prompt here if the chequesList is not empty before continuing to exit the form
    ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
  }

  const onChange = (e) => {
    const value = (e.target.type === 'number') ? parseFloat(e.target.value) : e.target.value
    setCheque({ ...cheque, [e.target.name]: value })
  }

  const onClickAddCheque = (e) => {
    const chequeDate = new Date(cheque.date)
    const chequeDateString = `${getMonthString(chequeDate.getMonth())} ${chequeDate.getDate()}, ${chequeDate.getFullYear()}`
    cheque.long_date = chequeDateString

    if (chequesList.length)
      if (editMode)
        chequesList[currentIndex] = cheque
      else
        setChequesList([ ...chequesList, cheque ])
    else
      setChequesList([ cheque ])

    setEditMode(false)

    // Reset/Clear cheque form
    setCheque(initCheque)
    removeChequeItemHighlight()
    chequeNumberRef.current.focus()
  }

  const totalChequeAmount = () => {
    if (chequesList.length) {
      const chequeSum = chequesList
      .map(cheque => cheque.amount)
      .reduce((prev, cur) => (prev + cur))
      return (chequeSum)
    }

    return (0)
  }

  const onClickDeleteCheque = (e) => {
    const chequeItem = e.target.closest('.cheque-item')
    const selectedCheque = chequesList.filter(cheque => (cheque.number !== chequeItem.id))
    delete selectedCheque.long_date
    setChequesList(selectedCheque)
  }

  const highlightSelectedChequeItemForEdit = (chequeIndex) => {
    const chequeItems = document.querySelectorAll('.cheque-item')
    chequeItems.forEach((chequeItem, i) => {
      if (i !== chequeIndex) chequeItem.classList.remove('cheque-item-highlight')
      else chequeItem.classList.add('cheque-item-highlight')
    })
  }

  const removeChequeItemHighlight = () => {
    const chequeItems = document.querySelectorAll('.cheque-item')
    chequeItems.forEach((chequeItem, i) =>  chequeItem.classList.remove('cheque-item-highlight'))
  }

  const onClickCheque = (e) => {
    if (e.target.closest('.close-button')) return

    const chequeItem = e.target.closest('.cheque-item')
    const chequeIndex = chequesList.findIndex(cheque => (cheque.number === chequeItem.id))
    setCurrentIndex(chequeIndex)

    setCheque ( chequesList.find(cheque => (cheque.number === chequeItem.id)) )

    setEditMode(true)
    chequeNumberRef.current.focus()

    highlightSelectedChequeItemForEdit(chequeIndex)
  }

  const onClickCancelEditCheque = (e) => {
    setCheque(initCheque)
    removeChequeItemHighlight()
    setEditMode(false)
    chequeNumberRef.current.focus()
  }

  useEffect(() => {
    if (chequesList.length === 0) chequeNumberRef.current.focus()
  }, [chequesList])

  useEffect(() => {
    setAddOK(cheque.number && cheque.date && cheque.bank && cheque.amount)
  }, [cheque])

  useEffect(() => {
    chequeNumberRef.current.focus()
  }, [])

  return (
    <React.Fragment>
      <div id='add-cheque-form-container'>
        <div id='add-cheque-form-block-container'>
          <div id='add-cheque-header-label'>Cheque Details</div>

          <div id='add-cheque-form-block'>
            <div className='input-container'>
              <div className='input-label'>Number</div>
              <input
                ref={chequeNumberRef}
                className='input-data top-anchor'
                name='number'
                type='text'
                value={cheque.number}
                onChange={onChange}
              />
            </div>

            <div className='input-container'>
              <div className='input-label'>Date</div>
              <input
                className='input-data'
                name='date'
                type='date'
                value={cheque.date}
                onChange={onChange}
              />
            </div>

            <div className='input-container'>
              <div className='input-label'>Bank</div>
              <input
                className='input-data'
                type='text'
                name='bank'
                value={cheque.bank}
                onChange={onChange}
              />
            </div>

            <div className='input-container'>
              <div className='input-label'>Amount</div>
              <input
                className='input-data'
                name='amount'
                type='number'
                min='0'
                value={cheque.amount}
                onChange={(e) => { e.target.value
                  ? setCheque({...cheque, amount: parseFloat(e.target.value)})
                  : setCheque({...cheque, amount: ''})
                }}
              />
            </div>
          </div>

          <div id='cheque-button-group-container'>
            <button
              disabled={!addOK}
              onClick={onClickAddCheque}
              id='add-cheque-button'
              className={ !addOK ? 'pospro-action-btn disabled-button' : 'pospro-action-btn' }>
              { (editMode) ? <span>Update</span> : <span>Add</span> }
            </button>
            <button
              style={{display: (editMode) ? 'block' : 'none'}}
              onClick={onClickCancelEditCheque}
              id='cancel-button'
              className='pospro-action-btn'>
              Cancel
            </button>
          </div>

        </div>

        <div id='cheques-list-block'>
          <div id='cheque-items-container'>
          {
            chequesList.map((cheque, index) => (
              <div onClick={onClickCheque} id={cheque.number} key={index} className='cheque-item'>
                <div className='cheque-number'><div>Number</div>{ cheque.number }</div>
                <div className='cheque-date'><div>Date</div>{ cheque.long_date }</div>

                <div style={{visibility: (editMode) ? 'hidden' : 'visible'}}>
                  <CloseButton onClick={onClickDeleteCheque}/>
                </div>

                <div className='bank-and-amount-container'>
                  <div className='bank-name'>{ cheque.bank }</div>
                  <div className='cheque-amount'>P { formatNumber(cheque.amount) }</div>
                </div>
              </div>
            ))
          }
          </div>
          <div id='cheque-summary-container'>
            <div id='cheque-total-item'>Total Item: <b>{ chequesList.length }</b></div>
            <div id='cheque-total-amount'>Total Amount: <b>P { formatNumber(totalChequeAmount()) }</b></div>
          </div>
        </div>
      </div>
      <div id='action-button-container'>
        <button
          onClick={onClickCancel}
          className='pospro-action-btn'>
          Cancel
        </button>
        <button
          disabled={ (((chequesList.length === 0) || editMode) && (!existingCheques)) }
          onClick={onClickApply}
          className={ (((chequesList.length === 0) || editMode) && (!existingCheques)) ? 'pospro-action-btn bottom-anchor disabled-button' : 'pospro-action-btn bottom-anchor' }>
          Apply
        </button>
      </div>
      <AddChequeFormStyle />
    </React.Fragment>
  )
}

export default React.memo(AddChequeForm)
